import i18next from 'i18next';

export const fallbackLng = 'en';
export const languages = [
  fallbackLng,
  'zh',
  'ar',
  'de',
  'es',
  'fil',
  'fr',
  'hi',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nl',
  'no',
  'pt',
  'ru',
  'th',
  'tr',
  'vi',
  'yue',
  'zh_tw',
  'ca'
];
export const defaultNS = 'translation';

export function getOptions(ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    fallbackNS: defaultNS,
    defaultNS,
    ns
  };
}

export function updateSources(lng = fallbackLng, ns = defaultNS, translation: Record<string, any>) {
  i18next.addResources(lng, ns, translation);
}
